import * as PIXI from 'pixi.js'
import load from './Loader'
import PastelFilter from './PastelFilter'
import svgs from '../imgs/*.svg'
// import tinycolor from 'tinycolor2'

export default class PixiStage {
  private app: PIXI.Application
  private ropesPoints: PIXI.Point[][] = []
  private tapis: PIXI.Container
  private cupWater: PIXI.Container
  private cupLight: PIXI.Container
  private straw: PIXI.Container

  constructor (wrapperSelector: string) {
    this.app = new PIXI.Application({ width: 800, height: 520, transparent: true })
    this.createSatege(document.querySelector(wrapperSelector))
  }

  private async createSatege(parent: Element) {
    parent.appendChild(this.app.view)
    this.app.renderer.backgroundColor = 0xffe8aa

    // const seaweedSpripes = (Array(5) as PIXI.Container[]).fill(null).map((item, i) => this.createSeaweed(
    //   1 + (Math.random() - 0.5),
    //   100 + i * 100 + (Math.random() - 0.5) * 40,
    //   600,
    //   1 + (Math.random() - 0.5) * 0.4,
    //   1 + (Math.random() - 0.5) * 0.5
    // ))
    // this.app.stage.addChild(...seaweedSpripes)

    // const katsuo = this.createKatsuo(310, 250)
    // katsuo.angle = -50
    // this.app.stage.addChild(katsuo)
  
    const text = new PIXI.Text('TAPIOCA',{fontFamily : 'impact', fontSize: 40, fill : 0x664422, align : 'left'});
    text.x = 60
    text.y = 100
    this.app.stage.addChild(text)
    const glFilter = new PastelFilter()
    text.filters = [glFilter]

  }

  public createKatsuo(x: number = 0, y: number = 0) {
    const katsuoPath = svgs['katsuo'] as string
    // ユーティリティで即時ロード:
    const katsuoTexture = PIXI.Texture.from(katsuoPath)
    const length = 318
    const rope = this.createRopeObj(katsuoTexture, length, 10)
    rope.position = new PIXI.Point(300, 250)
    rope.angle = -90
    rope.x = x
    rope.y = y
    const glFilter = new PastelFilter()
    glFilter.shColor1 = 0x336699
    glFilter.shColor2 = 0x6699cc
    rope.filters = [glFilter]
    return rope
  }

  public createSeaweed(speed: number = 1.0, x: number = 0, y: number = 0, sx: number = 1, sy: number = 1): PIXI.Container {
    const seaweedPath = svgs['seaweed'] as string
    const seaweedTexture = PIXI.Texture.from(seaweedPath)
    const length = 300
    const rope = this.createRopeObj(seaweedTexture, length, 10)
    rope.scale.x = sx
    rope.scale.y = sy
    rope.x = x
    rope.y = y- length / 2 * sy
    rope.angle = 180
    rope.filters = [new PastelFilter()]
    return rope
  }

  public createRopeObj(tex: PIXI.Texture, length: number = 200, count: number = 10): PIXI.Container {
    const points = (Array(count) as PIXI.Point[])
      .fill(null)
      .map((item, i) => new PIXI.Point(length / count * i, 0))
    const rope = new PIXI.SimpleRope(tex, points)
    this.ropesPoints.push(points)
    // rope.rotation = -Math.PI / 2
    const container = new PIXI.Container()
    container.addChild(rope)
    return container

  }

  public paintTapis(g: PIXI.Graphics, points: PIXI.Point[], r: number = 10) {
    points.forEach((p, i) => {
      const colorR = (i  * 0.35) % 1
      const c1 = [0x66, 0x33, 0x22]
      const c2 = [0x33, 0x22, 0x11]
      const c = c1.map((v1, i) => {
        const v2 = c2[i]
        return (v1 * colorR + v2 * (1 - colorR))
      })
      g.beginFill((c[0] << 16) + (c[1] << 8) + (c[2]) , 0.9)
      g.drawCircle(p.x, p.y, r)
    })
  }

  public updateRopePoints(sourcePoints: PIXI.Point[]): void {
    const sp0 = sourcePoints[0]
    this.ropesPoints.forEach(points => {
      const p0 =  points[0]
      points.forEach((p, i) => {
        p.x = p0.x + sourcePoints[i].x - sp0.x
        p.y = p0.y + sourcePoints[i].y - sp0.y
      })
    })
  } 

  public updateTapiPoints(sourcePoints: PIXI.Point[]): void {
    if(!this.tapis) {
      const bag = this.tapis = new PIXI.Container()
      const g = new PIXI.Graphics()
      bag.addChild(g)
      const filter = new PastelFilter()
      filter.thickness = 30
      bag.filters = [filter]
      this.app.stage.addChild(bag)
    }
    const g = this.tapis.children[0] as PIXI.Graphics
    g.clear()
    this.paintTapis(g, sourcePoints, 20)
  } 

  public updateCupPoints(sourcePoints: PIXI.Point[], outer: {lt: PIXI.Point, rt: PIXI.Point, lb: PIXI.Point, rb: PIXI.Point}): void {
    if(!this.cupWater) {
      this.cupWater = new PIXI.Container()
      this.cupWater.addChild(new PIXI.Graphics())
      this.app.stage.addChild(this.cupWater)
      const filter = new PastelFilter()
      filter.shColor1 = 0xff0000
      filter.shColor2 = 0xffffcc
      filter.thickness = 45
      this.cupWater.filters = [filter]
    }
    const g = this.cupWater.children[0] as PIXI.Graphics
    const c = 0xccaa77
    g.clear()
    g.beginFill(c, 0.93)
    g.lineStyle(18, c, 0.95)
    g.moveTo(sourcePoints[0].x, sourcePoints[0].y)
    sourcePoints.forEach(p => g.lineTo(p.x, p.y))
    g.closePath()
    g.endFill()

    if(!this.cupLight) {
      this.cupLight = new PIXI.Container()
      this.app.stage.addChild(this.cupWater)

      // カップの反射
      const lightG = new PIXI.Graphics()
      lightG.beginFill(0xffffff)
      lightG.drawPolygon([
        new PIXI.Point(10, 0),
        new PIXI.Point(80, 0),
        new PIXI.Point(outer.lb.x - outer.lt.x + 55, outer.lb.y - outer.lt.y),
        new PIXI.Point(outer.lb.x - outer.lt.x + 10, outer.lb.y - outer.lt.y)
      ])
      lightG.endFill()

      // カップの外形
      const ptDiff = (o: PIXI.Point, p: PIXI.Point): PIXI.Point => new PIXI.Point(p.x - o.x, p.y - o.y)
      lightG.beginFill(0xffffff, 0)
      lightG.lineStyle(20, 0x668899, 1, 1);
      lightG.drawPolygon([
        new PIXI.Point(0, 0),
        ptDiff(outer.lt, outer.rt),
        ptDiff(outer.lt, outer.rb),
        ptDiff(outer.lt, outer.lb),
      ])
      lightG.endFill()
      
      // フィルターの処理範囲を拡大するためのダミー描画 //
      lightG.lineStyle(0);
      lightG.beginFill(0xffffff, 0)
      lightG.drawCircle(-20, -20, 1)
      lightG.drawCircle(ptDiff(outer.lt, outer.rt).x, -20, 1)
      lightG.endFill()


      const filter = new PastelFilter()
      filter.shColor1 = 0xffffff
      filter.shColor2 = 0xffffff
      filter.thickness = 40
      this.cupLight.filters = [filter]
      this.cupLight.alpha = 0.97
      this.cupLight.addChild(lightG)
      this.app.stage.addChild(this.cupLight)
    }
    this.cupLight.x = outer.lt.x
    this.cupLight.y = outer.lt.y
    // 常に最前面に表示
    this.app.stage.addChild(this.cupLight)
  } 

  public updateStraw(x: number, y: number, w: number, h: number, r: number) {
    if(!this.straw) {
      this.straw = new PIXI.Container()
      this.app.stage.addChildAt(this.straw, 0)
      const filter = new PastelFilter()
      filter.shColor1 = 0xff0000
      filter.shColor2 = 0xff0000
      filter.thickness = 35
      this.straw.filters = [filter]
      const g = new PIXI.Graphics()
      g.beginFill(0xaa6633)
      g.drawRoundedRect(0, 0, w, h, 10)
      g.endFill()
      this.straw.addChild(g)
      g.pivot.x = w / 2
      g.pivot.y = h
    }
    const g = this.straw.children[0]
    g.x = x
    g.y = y
    g.rotation = r
  }

}

